import { normalizeItalianPhone } from './identity';
export type InviteAccessClient = {
  auth: {
    getSession: () => PromiseLike<{ data: { session: unknown | null } }>;
    signInAnonymously: () => PromiseLike<{
      data: { session: unknown | null };
      error: unknown;
    }>;
  };
  rpc: (
    name: string,
    args: Record<string, unknown>,
  ) => PromiseLike<{ data: unknown; error: { message: string } | null }>;
};
export type InvitePreview = { setlist_title: string; expires_at: string };
export async function getInvitePreview(client: InviteAccessClient, tokenValue: string) {
  const token = tokenValue.trim();
  if (!/^[a-f0-9]{64}$/i.test(token)) return null;
  const result = await client.rpc('get_invite_preview', { p_token: token });
  if (result.error || !result.data) return null;
  return result.data as InvitePreview;
}
export async function acceptInviteFromLink(
  client: InviteAccessClient,
  input: {
    token: string;
    displayName: string;
    nationalNumber: string;
    instrument: string;
  },
) {
  const token = input.token.trim();
  if (!/^[a-f0-9]{64}$/i.test(token)) throw new Error('invite unavailable');
  const phone = normalizeItalianPhone(input.nationalNumber);
  const displayName = input.displayName.trim();
  const instrument = input.instrument.trim();
  if (!displayName) throw new Error('display name required');
  if (!instrument) throw new Error('instrument required');
  const current = await client.auth.getSession();
  if (!current.data.session) {
    const signIn = await client.auth.signInAnonymously();
    if (signIn.error || !signIn.data.session) throw new Error('session unavailable');
  }
  const result = await client.rpc('accept_invite', {
    p_token: token,
    p_phone_e164: phone,
    p_display_name: displayName,
    p_instrument_role: instrument,
  });
  if (result.error) throw new Error(result.error.message);
  return result.data;
}
export function formatItalianPhone(value: string) {
  const digits = value.replace(/^\+39/, '');
  return `+39 ${digits.replace(/(\d{3})(?=\d)/, '$1 ')}`;
}
export function memberLabel({
  isCurrent = false,
  localContactName,
  phone,
}: {
  isCurrent?: boolean;
  localContactName?: string | null;
  phone: string;
}) {
  if (isCurrent) return 'Tu';
  return localContactName?.trim() || formatItalianPhone(phone);
}
